var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStTvs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_364_3818)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#F2613F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5455,
    y: 11.5455,
    width: 64.9091,
    height: 64.9091,
    rx: 32.4545,
    stroke: "white",
    strokeWidth: 3.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 44.0394C56.6667 46.2825 56.1056 48.3672 54.9836 50.2936C53.8615 52.22 52.3378 53.7637 50.4125 54.9248C50.0431 55.1623 49.7855 55.4859 49.6398 55.8954C49.4942 56.305 49.5274 56.6939 49.7396 57.0623C49.9507 57.4582 50.2737 57.7157 50.7086 57.835C51.1435 57.9543 51.5594 57.9078 51.9563 57.6957C54.4104 56.2707 56.3368 54.3443 57.7354 51.9165C59.134 49.4887 59.8333 46.863 59.8333 44.0394C59.8333 43.3533 59.7869 42.6804 59.694 42.0207C59.6011 41.3609 59.476 40.7012 59.3188 40.0415L59.8333 40.3582C60.2028 40.5957 60.5986 40.6553 61.0208 40.5371C61.4431 40.4189 61.7597 40.1745 61.9708 39.804C62.1819 39.4335 62.2284 39.0308 62.1102 38.5959C61.9919 38.161 61.7476 37.838 61.3771 37.6269L56.5875 34.8561C56.2181 34.645 55.8154 34.5991 55.3794 34.7183C54.9435 34.8376 54.6205 35.0814 54.4104 35.4498L51.6396 40.1998C51.4285 40.5693 51.382 40.972 51.5003 41.4079C51.6185 41.8439 51.8628 42.1669 52.2333 42.3769C52.6038 42.587 53.006 42.6334 53.4398 42.5163C53.8737 42.3991 54.1972 42.1547 54.4104 41.7832L55.7563 39.4478C56.0465 40.1866 56.2708 40.9387 56.4292 41.704C56.5875 42.4693 56.6667 43.2478 56.6667 44.0394ZM44 31.3332C45.082 31.3332 46.1507 31.472 47.2063 31.7496C48.2618 32.0272 49.2646 32.4294 50.2146 32.9561C50.6104 33.1672 51.0258 33.24 51.4607 33.1746C51.8956 33.1091 52.2191 32.8912 52.4313 32.5207C52.6688 32.0984 52.7215 31.6699 52.5896 31.235C52.4576 30.8001 52.1806 30.4634 51.7583 30.2248C50.5708 29.5387 49.3237 29.0241 48.0169 28.6811C46.7101 28.338 45.3712 28.1665 44 28.1665C41.9153 28.1665 39.9161 28.556 38.0023 29.335C36.0886 30.114 34.3802 31.2419 32.8771 32.7186V32.1248C32.8771 31.6762 32.7251 31.3004 32.4211 30.9975C32.1171 30.6946 31.7413 30.5426 31.2938 30.5415C30.8462 30.5404 30.4699 30.6924 30.1648 30.9975C29.8598 31.3026 29.7083 31.6783 29.7104 32.1248V37.6665C29.7104 38.1151 29.8619 38.4914 30.1648 38.7954C30.4678 39.0994 30.8441 39.2509 31.2938 39.2498H36.8354C37.284 39.2498 37.6598 39.0978 37.9628 38.7938C38.2657 38.4898 38.4177 38.1141 38.4188 37.6665C38.4198 37.2189 38.2678 36.8432 37.9628 36.5392C37.6577 36.2352 37.2819 36.0832 36.8354 36.0832H34.1042C35.3181 34.579 36.7826 33.4116 38.4979 32.5808C40.2132 31.7501 42.0472 31.3342 44 31.3332ZM34.4208 52.3519C33.4181 51.1908 32.6528 49.9109 32.125 48.5123C31.5972 47.1137 31.3333 45.6491 31.3333 44.1186C31.3333 43.67 31.1813 43.2741 30.8773 42.9311C30.5733 42.588 30.1976 42.4165 29.75 42.4165C29.3025 42.4165 28.9261 42.588 28.6211 42.9311C28.316 43.2741 28.1646 43.67 28.1667 44.1186C28.1667 45.8339 28.4374 47.4895 28.9789 49.0855C29.5204 50.6815 30.3052 52.1661 31.3333 53.5394C32.3615 54.9127 33.5817 56.087 34.994 57.0623C36.4063 58.0377 37.9438 58.7634 39.6063 59.2394L39.2104 59.4769C38.841 59.688 38.6035 60.0116 38.4979 60.4475C38.3924 60.8834 38.4451 61.2856 38.6563 61.654C38.8674 62.0224 39.184 62.2599 39.6063 62.3665C40.0285 62.4731 40.4243 62.4203 40.7938 62.2082L45.6229 59.4373C45.9924 59.2262 46.2362 58.9027 46.3544 58.4668C46.4726 58.0308 46.4267 57.6286 46.2167 57.2603L43.4458 52.4707C43.2347 52.1012 42.9181 51.8637 42.4958 51.7582C42.0736 51.6526 41.6778 51.7054 41.3083 51.9165C40.9389 52.1276 40.6945 52.4511 40.5753 52.8871C40.456 53.323 40.5024 53.7252 40.7146 54.0936L42.1792 56.5873C40.675 56.3762 39.2563 55.9076 37.9232 55.1813C36.59 54.4551 35.4226 53.512 34.4208 52.3519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_364_3818",
    x: -0.818182,
    y: -0.818182,
    width: 89.6364,
    height: 89.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.568627 0 0 0 0 0.611765 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_364_3818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_364_3818",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStTvs);
export default __webpack_public_path__ + "static/media/st_tvs.79b868dcab59ece0b5f63b4cb748cf78.svg";
export { ForwardRef as ReactComponent };